/**
 * Which DUX rail item is current from the Vue route.
 * Empty string = a desktop page with no matching primary (company card, wizards).
 * Radar GTM pivot still highlights Radar — no separate My GTMs rail item.
 */
export function desktopRoomFromRoute (route) {
  if (!route) return 'matrix'
  const name = route.name
  if (name === 'profile' || name === 'userProfile') return 'profile'
  if (name === 'companyConsole') return 'gold'
  if (name === 'gtmMaestro') return 'gtm'
  if (name === 'tubaBlast') return 'tuba'
  if (name === 'landing') {
    const tab = route.query && route.query.tab
    if (tab === 'manage' || tab === 'radar' || tab === 'import' || tab === 'matrix') {
      return tab
    }
    return 'matrix'
  }
  return ''
}
